export class IosStrategy {
  onSuccess(boxNumber, citiboxId, deliveryId) {
    window?.webkit?.messageHandlers?.success?.postMessage({
      boxNumber,
      citiboxId,
      deliveryId,
    });
  }

  onError(errorCode) {
    window?.webkit?.messageHandlers?.error?.postMessage({
      code: errorCode,
    });
  }

  onFail(failureCode) {
    window?.webkit?.messageHandlers?.fail?.postMessage({
      code: failureCode,
    });
  }

  onCancel(cancelCode) {
    window?.webkit?.messageHandlers?.cancel?.postMessage({
      code: cancelCode,
    });
  }

  openBLE(
    url,
    mac,
    ssid,
    serviceUUID,
    scommandUUID,
    sreplyUUID,
    openToken,
    otaServiceUUID,
    otaControlUUID,
    otaDataUUID,
  ) {
    window?.webkit?.messageHandlers?.openBLE?.postMessage(
      url,
      ssid,
      serviceUUID,
      scommandUUID,
      sreplyUUID,
      openToken,
      otaServiceUUID,
      otaControlUUID,
      otaDataUUID,
    );
  }

  cancelOpenBLE() {
    window?.webkit?.messageHandlers?.cancelOpenBLE?.postMessage();
  }

  blePermissionsStatus() {
    window?.webkit?.messageHandlers?.blePermissionsStatus?.postMessage();
  }

  characteristicsSDK() {
    window?.webkit?.messageHandlers?.characteristicsSDK?.postMessage();
  }

  sdkInfo() {
    window?.webkit?.messageHandlers?.sdkInfo?.postMessage();
  }

  onSessionToken(sessionToken) {
    window?.webkit?.messageHandlers?.onSessionToken?.postMessage({
      sessionToken: sessionToken,
    });
  }
}
